//  @ts-nocheck
// biome-ignore-all lint: 관심없음

'use client';

import { cn } from '@module/lib/utils';
import { buttonVariants } from '@pc/components/ui/button';
import { startOfDay } from 'date-fns';
import { ko } from 'date-fns/locale';
import * as React from 'react';
import { DayPicker } from 'react-day-picker';

export type CalendarProps = React.ComponentProps<typeof DayPicker> & {
  selected: Date;
};

function CustomCaption({ displayMonth, onMonthChange }) {
  const handlePreviousMonth = () => {
    const previousMonth = new Date(displayMonth);
    previousMonth.setMonth(displayMonth.getMonth() - 1);
    onMonthChange(previousMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(displayMonth);
    nextMonth.setMonth(displayMonth.getMonth() + 1);
    onMonthChange(nextMonth);
  };

  const handlePreviousYear = () => {
    const previousYear = new Date(displayMonth);
    previousYear.setFullYear(displayMonth.getFullYear() - 1);
    onMonthChange(previousYear);
  };

  const handleNextYear = () => {
    const nextYear = new Date(displayMonth);
    nextYear.setFullYear(displayMonth.getFullYear() + 1);
    onMonthChange(nextYear);
  };

  const year = displayMonth.getFullYear();
  const month = String(displayMonth.getMonth() + 1).padStart(2, '0');

  return (
    <div className='flex items-center justify-center gap-5'>
      <button className='text-[24px] text-[#999]' onClick={handlePreviousYear}>
        &lt;&lt;
      </button>
      <button className='text-[24px] text-[#999]' onClick={handlePreviousMonth}>
        &lt;
      </button>
      <span className='font-nanum-square text-[24px] font-bold text-baseFg'>
        {year} &nbsp;{month}
      </span>
      <button className='text-[24px] text-[#999]' onClick={handleNextMonth}>
        &gt;
      </button>
      <button className='text-[24px] text-[#999]' onClick={handleNextYear}>
        &gt;&gt;
      </button>
    </div>
  );
}

function Calendar({ className, classNames, showOutsideDays = false, ...props }: CalendarProps) {
  const [selectedMonth, setSelectedMonth] = React.useState(props.selected);
  const [today] = React.useState(() => new Date());
  return (
    <DayPicker
      locale={ko}
      showOutsideDays={showOutsideDays}
      className={cn('bg-colorBg02 p-3', className)}
      classNames={{
        months: 'flex flex-col space-y-4',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center text-baseFg',
        caption_label: 'text-sm font-medium text-baseFg',
        nav: 'space-x-1 flex items-center',
        nav_button: 'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
        nav_button_previous: 'absolute left-1',
        nav_button_next: 'absolute right-1',
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex',
        head_cell:
          'text-colorFg18 rounded-md w-full font-normal text-[0.8rem] first:text-[#ef312a] last:text-[#ef312a]',
        row: 'flex w-full mt-2',
        cell: 'h-9 w-full text-center text-sm py-0 px-1 relative [&:has([aria-selected].day-range-end)]:rounded-r-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20',
        day: cn(
          buttonVariants({ variant: 'ghost' }),
          'h-9 w-full p-0 font-normal aria-selected:opacity-100 text-colorFg01 hover:bg-colorBg23 hover:text-colorFg01',
        ),
        day_range_end: 'day-range-end',
        day_selected: 'bg-primary text-white hover:bg-primary focus:bg-primary focus:text-white',
        day_today: 'bg-colorBg23 text-colorFg02',
        day_outside: 'text-colorFg01 opacity-50 aria-selected:bg-primary aria-selected:text-white',
        day_disabled: 'text-colorFg01 opacity-50',
        day_range_middle: 'aria-selected:bg-colorBg23 aria-selected:text-colorFg02',
        day_hidden: 'invisible',

        ...classNames,
      }}
      modifiers={{
        past: (date) => startOfDay(date) < startOfDay(today),
      }}
      modifiersClassNames={{
        past: 'text-colorFg01 opacity-50',
      }}
      month={selectedMonth}
      onMonthChange={setSelectedMonth}
      components={{
        Caption: (props) => (
          <CustomCaption {...props} displayMonth={props.displayMonth} onMonthChange={setSelectedMonth} />
        ),
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
